import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { UrlHelper } from '@shared/helpers/UrlHelper';
import { SubscriptionStartType } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { AppComponentBase } from 'shared/common/app-component-base';
import { LinkedAccountsModalComponent } from '@app/shared/layout/linked-accounts-modal.component';
import { UserDelegationsModalComponent } from '@app/shared/layout/user-delegations-modal.component';
import { LoginAttemptsModalComponent } from '@app/shared/layout/login-attempts-modal.component';
import { ChangePasswordModalComponent } from '@app/shared/layout/profile/change-password-modal.component';
import { ChangeProfilePictureModalComponent } from '@app/shared/layout/profile/change-profile-picture-modal.component';
import { MySettingsModalComponent } from '@app/shared/layout/profile/my-settings-modal.component';
import { NotificationSettingsModalComponent } from '@app/shared/layout/notifications/notification-settings-modal.component';
import { UserNotificationHelper } from '@app/shared/layout/notifications/UserNotificationHelper';
import { QuirkService } from './shared/services/quirk.service';
import { MyCommandCenterService } from './main/command-center/my-command-center.service';
import './shared/extensions/common-extensions';
import './shared/extensions/my-policies-extensions';
import { environment } from '../environments/environment';
import { User } from 'oidc-client';
import { IdentityAuthProviderService } from '@app/shared/common/auth/identity-auth-provider.service';
export const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

/**
 * Marker attribute on the injected Elevate AI widget <link>/<script>, so a re-init cannot append
 * the bundle twice. Module-level rather than a static class field: tslint member-ordering requires
 * statics ahead of instance fields, and `npm start` runs `ng lint` before `ng serve`.
 */
const AI_CHAT_ASSET_MARKER = 'data-elevate-ai-widget';

export function changeTemplatePopupGlobal(item: string, item1: string, forceRed: boolean = false) {
    let iconDiv = document.getElementsByClassName('swal2-icon-show');
        if (iconDiv && iconDiv[0].classList.contains('swal2-icon-show')) {
            iconDiv[0].innerHTML = '';
            (iconDiv[0] as any).style = 'display: none;';
            iconDiv[0].classList.remove('swal2-icon-show');

            let imageDiv = document.getElementsByClassName('swal2-image');

            if (imageDiv) {
                (imageDiv[0] as any).style = '';
                imageDiv[0].classList.add('swal2-icon');
                (imageDiv[0] as any).src  = `src="../../../../assets/common/images/location_exclamation${forceRed ? '_red' : ''}.svg`;
                imageDiv[0].classList.remove('swal2-image');
            }
        }

    if (item !== undefined) {
        (document.getElementsByClassName('swal2-confirm')[0] as any).innerText = item;
        document.getElementsByClassName('swal2-confirm')[0].classList.add('modal-button-clr');
        document.getElementsByClassName('swal2-confirm')[0].classList.add('border-radius-55');
        document.getElementsByClassName('swal2-confirm')[0].classList.add('font-size-12');
        document.getElementsByClassName('swal2-confirm')[0].classList.add('btn-primary');

        if (forceRed) {
            document.getElementsByClassName('swal2-confirm')[0].classList.add('bg-cust-portal-red');
        }
    } else {
        document.getElementsByClassName('swal2-confirm')[0].classList.add('d-none');
    }

    if (item1 !== undefined) {
        (document.getElementsByClassName('swal2-cancel')[0] as any).innerText = item1;
        document.getElementsByClassName('swal2-cancel')[0].classList.add('border-radius-55');
        document.getElementsByClassName('swal2-cancel')[0].classList.add('font-size-12');
    } else {
        document.getElementsByClassName('swal2-cancel')[0].classList.add('d-none');
    }

}

export function isMobileView_NewGlobal() {
    if (window.innerWidth < 768) {
        return true;
    } else {
        return false;
    }
}


@Component({
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less']
})
export class AppComponent extends AppComponentBase implements OnInit {

    subscriptionStartType = SubscriptionStartType;
    theme: string;
    installationMode = true;

    /** Bound by *ngIf in app.component.html. Build-time flag - see environments/environment.ts. */
    aiChatEnabled = environment.aiChat && environment.aiChat.enabled;
    /** MCP server base URL, bound to the server-url attribute in the template. */
    aiChatServerUrl = environment.aiChat ? environment.aiChat.serverUrl : '';

    @ViewChild('loginAttemptsModal', { static: true }) loginAttemptsModal: LoginAttemptsModalComponent;
    @ViewChild('linkedAccountsModal') linkedAccountsModal: LinkedAccountsModalComponent;
    @ViewChild('userDelegationsModal', { static: true }) userDelegationsModal: UserDelegationsModalComponent;
    @ViewChild('changePasswordModal', { static: true }) changePasswordModal: ChangePasswordModalComponent;
    @ViewChild('changeProfilePictureModal', { static: true }) changeProfilePictureModal: ChangeProfilePictureModalComponent;
    @ViewChild('mySettingsModal', { static: true }) mySettingsModal: MySettingsModalComponent;
    @ViewChild('notificationSettingsModal', { static: true }) notificationSettingsModal: NotificationSettingsModalComponent;
    @ViewChild('chatBarComponent') chatBarComponent;
    isQuickThemeSelectEnabled: boolean = this.setting.getBoolean('App.UserManagement.IsQuickThemeSelectEnabled');
    IsSessionTimeOutEnabled: boolean = this.setting.getBoolean('App.UserManagement.SessionTimeOut.IsEnabled') && this.appSession.userId != null;

    public constructor(
        injector: Injector,
        private _userNotificationHelper: UserNotificationHelper,
        private quirkService: QuirkService,
        private commandService: MyCommandCenterService,
        private _identityAuthProvider: IdentityAuthProviderService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        //this._userNotificationHelper.settingsModal = this.notificationSettingsModal;
        this.theme = abp.setting.get('App.UiManagement.Theme').toLocaleLowerCase();
        this.installationMode = UrlHelper.isInstallUrl(location.href);
        this.quirkService.init();
        this.registerModalOpenEvents();

        // Isolated: a widget failure must never take down the portal's own init.
        if (this.aiChatEnabled) {
            try {
                this.initAiChatWidget();
            } catch (e) {
                console.error('[ai-chat] widget init failed; portal continues.', e);
            }
        }
        //if (this.appSession.application) {
        //    SignalRHelper.initSignalR(() => { this._chatSignalrService.init(); });
        //}
    }

    // ---------------------------------------------------------------------------------------
    // Elevate AI chat widget (testbed). Plain DOM wiring, deliberately not an Angular component:
    // <elevate-chat-launcher> is a Custom Element from a self-contained bundle that ships its own
    // Angular runtime, so it is driven by attributes rather than Angular bindings.
    //
    // TOKEN FLOW - push, not pull. The widget has no token-request event; its contract is a `token`
    // ATTRIBUTE which it re-reads on every outbound request. So we set it once from the current
    // session and again whenever oidc-client loads a renewed user. `automaticSilentRenew` is
    // already on, so this rides the EXISTING refresh lifecycle - no second timer.
    //
    // The token is the IDENTITYSERVER one (via IdentityAuthProviderService), NOT
    // `abp.auth.getToken()`. The MCP server validates IdentityServer-issued tokens; the ABP token
    // is issued by this application's own Web.Host and would be rejected. See README.
    // ---------------------------------------------------------------------------------------
    private initAiChatWidget(): void {
        this.injectAiChatAssets();

        // Initial supply: whatever the session holds right now.
        this._identityAuthProvider.getCurrentAccessToken().then(token => this.pushAiChatToken(token));

        // Refresh supply: every silent renew and the initial sign-in both raise this.
        this._identityAuthProvider.onUserLoaded((user: User) => {
            this.pushAiChatToken(user && user.access_token ? user.access_token : null);
        });
    }

    private pushAiChatToken(token: string): void {
        const el = document.querySelector('elevate-chat-launcher');
        if (!el) {
            return;
        }
        // A blank read is pushed as an empty attribute rather than left stale, so the widget fails
        // cleanly instead of retrying with a token we already know is gone.
        el.setAttribute('token', token || '');
    }

    private injectAiChatAssets(): void {
        if (document.querySelector('[' + AI_CHAT_ASSET_MARKER + ']')) {
            return;
        }

        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = environment.aiChat.stylesUrl;
        link.setAttribute(AI_CHAT_ASSET_MARKER, 'styles');
        document.head.appendChild(link);

        const script = document.createElement('script');
        script.type = 'module'; // REQUIRED - the bundle is an ES module.
        script.src = environment.aiChat.widgetUrl;
        script.setAttribute(AI_CHAT_ASSET_MARKER, 'script');
        script.onerror = () => console.error(
            '[ai-chat] Failed to load the widget bundle from ' + environment.aiChat.widgetUrl);
        document.head.appendChild(script);
    }

    subscriptionStatusBarVisible(): boolean {
        return this.appSession.tenantId > 0 &&
            (this.appSession.tenant.isInTrialPeriod ||
                this.subscriptionIsExpiringSoon());
    }

    subscriptionIsExpiringSoon(): boolean {
        if (this.appSession.tenant.subscriptionEndDateUtc) {
            return moment().utc().add(AppConsts.subscriptionExpireNootifyDayCount, 'days') >= moment(this.appSession.tenant.subscriptionEndDateUtc);
        }

        return false;
    }

    registerModalOpenEvents(): void {
        abp.event.on('app.show.loginAttemptsModal', () => {
            this.loginAttemptsModal.show();
        });

        abp.event.on('app.show.linkedAccountsModal', () => {
            this.linkedAccountsModal.show();
        });

        abp.event.on('app.show.userDelegationsModal', () => {
            this.userDelegationsModal.show();
        });

        abp.event.on('app.show.changePasswordModal', () => {
            this.changePasswordModal.show();
        });

        abp.event.on('app.show.changeProfilePictureModal', () => {
            this.changeProfilePictureModal.show();
        });

        abp.event.on('app.show.mySettingsModal', () => {
            this.mySettingsModal.show();
        });
    }

    getRecentlyLinkedUsers(): void {
        abp.event.trigger('app.getRecentlyLinkedUsers');
    }

    onMySettingsModalSaved(): void {
        abp.event.trigger('app.onMySettingsModalSaved');
    }
}
